/** @module csi/action/ThreeDDocumentUploadController */
define([
	"dojo/_base/declare",
	"dojo/Deferred",
	"underscore",
	"csi/action/ActionView",
	"csi/action/Controller",
	"csi/action/NewFileController",
	"csi/comm/PostRequest",
	"csi/def",
	"csi/html",
	"csi/image/_base",
	"csi/locale",
	"csi/reflection",
	"csi/sessionConstants",
	"csi/util",
	"csi/xml"
], function (declare, Deferred, _, ActionView, Controller, NewFileController, PostRequest, def, html, csiImage, locale, reflection, sessionConstants, util, xml) {

	return declare(NewFileController, {
		/**
		 * Return ActionView for form if 3dMaterialForm view is not available.
		 * @return {ActionView}
		 */
		getActionView: function () {
			var rc = reflection.getClass("Document");
			var defView = def.getClassViewDef(rc, "3DForm");
			return new ActionView(this, defView);
		},

		/**
		 * Tests whether an extension is a Clo hardware file extension
		 * @param {string} extension
		 * @return {boolean}
		 */
		isCloType: function (extension) {
			let extensions = ["zfab", "trm", "btn", "bth", "zpac", "sst", "zsp", "zpl", "zsd"];
			return _.contains(extensions, extension);
		},

		/**
		 * @override
		 * Publish request to create new 3d material document
		 */
		process: function () {
			const node = this.getNode();
			const fd = this.getFormData();
			const req = new PostRequest("SiteAdmin", "Create3DDocument");
			req.addParameter("Name", fd.getFieldValue(xml.ATTR_NAME));
			req.addParameter("ParentURL", node.DocumentsAndComments);
			req.addParameter("SessionURL", sessionConstants.sessionUrl);
			req.addFiles(fd.getFieldValueAsFile("SourceFile"), "SourceFile");
			req.addParameter("DefaultImage", fd.getFieldValue("DefaultImage"));
			req.addParameter("Propagate3DMaterials", fd.getFieldValue("3DPropagateToExistingColorMaterials"));

			if (this.isCloType(util.getFileExtension(fd.getFieldValue("SourceFile")))) {
				const item = fd.getField("DefaultImage").m_control.item;

				if (item && item.rawSrc) {
					req.addParameter("DefaultImageFile", html.b64toBlob(item.rawSrc, "image/" + item.ext));
				}
			}

			this.displayProgressDialog({
				closable: false,
				message: locale.resource("Action_ProgressWait")
			});

			this.waitForPublish(req.post());
		}
	});
});